import { render } from "./TheHeaderLogo.vue?vue&type=template&id=1dc7c3e0"
import script from "./TheHeaderLogo.vue?vue&type=script&lang=js"
export * from "./TheHeaderLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__